import React from 'react';
import { withFormsy } from 'formsy-react';
import { FormControlLabel, Checkbox, FormHelperText } from '@mui/material';

class CheckboxInput extends React.Component {
  constructor(props) {
    super(props);
    this.props.setValue(this.props.value || '0', false);

    this.changeValue = this.changeValue.bind(this);
  }

  changeValue(event) {
    this.props.setValue(event.target.checked ? '1' : '0');
  }

  render() {
    const { name, label, hint, value, errorMessage, isPristine } = this.props;
    const isError = !isPristine && errorMessage != null;

    return (
      <div className="input-container">
        <FormControlLabel style={{width: '100%'}}
          control={
            <Checkbox id={name} checked={value == '1'} onChange={this.changeValue} value={name} />
          }
          label={label}
        />

        <span aria-live="polite">
          {!isPristine && errorMessage &&
            <FormHelperText error={isError}>{errorMessage}</FormHelperText>
          }
        </span>
        {hint &&
          <FormHelperText style={{marginTop: 0, marginBottom: 10}}>{hint}</FormHelperText>
        }
      </div>
    );
  }
}

export default withFormsy(CheckboxInput);
